<template>
    <b-modal
        id="modalantechhealthtrackui"
        ref="modalantechhealthtrackui"
        :lazy="true"
        title-tag="h2"
        centered
        size="xl"
        title="Antech HealthTracks"
        hideHeaderClose
        :hide-footer="true"
        @hide="close"
        no-close-on-backdrop
    >
        <div slot="modal-header" class="d-flex justify-content-between w-100">
            <h2 class="d-md-block d-none my-2">Antech HealthTracks</h2>
            <span class="align-self-center text-danger">
                <button class="btn btn-primary" @click="close">Exit</button>
            </span>
        </div>

        <div class="modal-body" style="min-height: 5rem">
            <div id="pims-immersion-iframe-container">
                <iframe
                    id="pims-immersion-iframe-app"
                    class="pims-immersion-iframe-app"
                    :src="`${iframe.src}accessToken=${accessToken}&AccessionId=${labAccessionId}&dockable=false`"
                    :height="iframe.style.height"
                    :width="iframe.style.width"
                >
                </iframe>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    data() {
        return {
            labAccessionId: "",
            accessToken: "",
            iframe: {
                src: process.env.ANTECH_IMMERSE_URL + "?",
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "550px"
                }
            }
        };
    },
    methods: {
        open(params) {
            let self = this;

            self.labAccessionId = params.lab_accession_id;
            self.accessToken = params.access_token;

            this.$refs.modalantechhealthtrackui.show();
        },
        close() {
            this.$refs.modalantechhealthtrackui.hide();
            this.$root.$emit("dialog-closed");
        }
    }
};
</script>
<style>
@media (max-width: 979px) {
    #modalantechhealthtrackui.modal.fade.in {
        top: 0px;
        left: 0px;
    }
}

@media (min-width: 992px) {
    .modal-xl {
        max-width: 990px !important;
    }
}

@media (min-width: 1200px) {
    .modal-xl {
        max-width: 1140px !important;
    }
}

@media (min-width: 1300px) {
    .modal-xl {
        max-width: 1250px !important;
    }
}

#modalantechhealthtrackui .modal-body {
    background-color: white;
    padding: 0px;
}

#modalantechhealthtrackui {
    overflow-x: auto;
}

#pims-immersion-iframe-container {
    position: relative;
}
</style>
